import { cn } from '../../lib/utils'

/** Hover/focus tooltip for compact controls (e.g. header + table icon actions). */
export function Tooltip({ label, children, className, side = 'bottom' }) {
  const isTop = side === 'top'

  return (
    <span className={cn('group/tooltip relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute left-1/2 z-[110] -translate-x-1/2 whitespace-nowrap rounded-md bg-ink-900 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg transition-all duration-150',
          'group-hover/tooltip:translate-y-0 group-hover/tooltip:opacity-100 group-focus-within/tooltip:translate-y-0 group-focus-within/tooltip:opacity-100',
          isTop
            ? 'bottom-[calc(100%+6px)] translate-y-1'
            : 'top-[calc(100%+6px)] -translate-y-1'
        )}
      >
        {label}
        <span
          aria-hidden
          className={cn(
            'absolute left-1/2 -translate-x-1/2 border-[5px] border-transparent',
            isTop
              ? 'top-full border-t-ink-900'
              : 'bottom-full border-b-ink-900'
          )}
        />
      </span>
    </span>
  )
}
